(function () {
  const breakpoint_tablet = 990;
  const containerWidth = window.innerWidth;
  const isMobile = containerWidth < breakpoint_tablet;
  const cartFooterLayout = document.querySelector('#main-cart-footer')?.getBoundingClientRect();
  if (!isMobile && cartFooterLayout) {
    document.querySelector('.pd-sticky-bar').style.setProperty("--left-desktop", cartFooterLayout.left + 'px');
    document.querySelector('.pd-sticky-bar').style.setProperty("--width-desktop", cartFooterLayout.width + 'px');
  }

  function getGwpDataFromDom(root = document) {
    const dataEl = root.querySelector('#pd-cart__api-gwp');
    if (!dataEl) {
      return null;
    }

    const raw = dataEl.textContent || dataEl.innerHTML;
    if (!raw) {
      return null;
    }

    try {
      function parseCartDebugRows(rawValue = '') {
        if (typeof rawValue !== 'string' || !rawValue) {
          return [];
        }

        return rawValue
          .split(';')
          .filter(Boolean)
          .map((row) => {
            const separatorIndex = row.indexOf(':');
            if (separatorIndex < 0) {
              return null;
            }

            const productId = row.slice(0, separatorIndex);
            const valuesRaw = row.slice(separatorIndex + 1);
            const values = valuesRaw.split('|').filter(Boolean);
            return { productId, values };
          })
          .filter(Boolean);
      }

      let parsed;
      try {
        parsed = JSON.parse(raw.trim());
      } catch (primaryError) {
        parsed = JSON.parse(raw.replaceAll('\n', '').trim());
      }
      parsed.forEach((obj, i) => {
        const tagRows = parseCartDebugRows(obj.cartItemsTags);
        const collectionRows = parseCartDebugRows(obj.cartItemsCollections);

        console.log(`[GWP Product] campaign[${i}] "${obj.campaignLabel}"`, {
          shouldAddGiftToCart: obj.shouldAddGiftToCart,
          conditionMet: obj.conditionMet,
          qualifyingQuantity: obj.qualifyingQuantity,
          selectedGiftQuantity: obj.selectedGiftQuantity,
          allowedGiftQuantity: obj.allowedGiftQuantity,
          applicableTags: obj.applicableTags,
          rewardProductsCount: obj.rewardProductsCount,
          selectedGiftLineItems: obj.selectedGiftLineItems,
          cartItemsTags: obj.cartItemsTags || '(empty)',
          cartItemsCollections: obj.cartItemsCollections || '(empty)'
        });

        if (tagRows.length) {
          console.table(tagRows.map((row) => ({
            productId: row.productId,
            tags: row.values.join(', ')
          })));
        }

        if (collectionRows.length) {
          console.table(collectionRows.map((row) => ({
            productId: row.productId,
            collections: row.values.join(', ')
          })));
        }
      });
      return parsed;
    } catch (error) {
      console.warn('GWP data parse failed', error);
      return null;
    }
  }

  async function refreshCartDrawerContents() {
    const cartDrawerItems = document.getElementById('cart-drawer-items');
    if (!cartDrawerItems) {
      return;
    }

    try {
      const response = await fetch(`${routes.cart_url}?view=items-modal`);
      const htmlText = await response.text();
      const html = new DOMParser().parseFromString(htmlText, 'text/html');
      const updated = html.getElementById('cart-drawer-items');
      if (updated) {
        cartDrawerItems.innerHTML = updated.innerHTML;
      }
    } catch (error) {
      console.warn('Cart drawer refresh failed', error);
    }
  }

  async function removeFreeGiftWithGWP(gwpArr = []) {
    const updates = {}

    function parseSelectedGiftLineItems(rawValue = '') {
      if (typeof rawValue !== 'string' || !rawValue) {
        return [];
      }

      return rawValue
        .split('|')
        .filter(Boolean)
        .map((entry) => {
          const [key = '', quantityRaw = '0'] = entry.split('::');
          return {
            key,
            quantity: Number(quantityRaw || 0)
          };
        })
        .filter((lineItem) => lineItem.key);
    }

    for (let gwpObj of gwpArr) {
      if (!gwpObj.shouldAddGiftToCart && !gwpObj.conditionMet) {
        const selectedGiftLineItems = parseSelectedGiftLineItems(gwpObj.selectedGiftLineItems);
        if (selectedGiftLineItems.length) {
          for (const lineItem of selectedGiftLineItems) {
            if (lineItem?.key) {
              updates[lineItem.key] = 0;
            }
          }
        } else {
          const variantIds = gwpObj.selectedGiftVariantId.split(',').filter(x => x);
          for (let variantId of variantIds) {
            updates[variantId] = 0;
          }
        }
      }

      if (gwpObj.conditionMet) {
        const allowedGiftQuantity = Number(gwpObj.allowedGiftQuantity || 0);
        const selectedGiftQuantity = Number(gwpObj.selectedGiftQuantity || 0);
        const selectedGiftLineItems = parseSelectedGiftLineItems(gwpObj.selectedGiftLineItems);

        if (selectedGiftQuantity > allowedGiftQuantity && selectedGiftLineItems.length) {
          let remainingAllowedQuantity = allowedGiftQuantity;

          selectedGiftLineItems.forEach((lineItem) => {
            if (!lineItem?.key) {
              return;
            }

            const currentLineQty = Number(lineItem.quantity || 0);
            const nextLineQty = Math.max(0, Math.min(currentLineQty, remainingAllowedQuantity));
            remainingAllowedQuantity = Math.max(0, remainingAllowedQuantity - nextLineQty);

            if (currentLineQty !== nextLineQty) {
              updates[lineItem.key] = nextLineQty;
            }
          });
        }
      }
    }

    // remove added gifts not available in all reward collections
    const allGiftVariantIds = gwpArr.flatMap(x => x.giftVariantId.split(',').filter(x => x));
    const addedGiftVariantIds = [...document.querySelectorAll('cart-remove-button[data-gwp]')].map(ele => ele.getAttribute("data-variantid"));
    const addedGiftVariantIdsNotInAllGifts = addedGiftVariantIds.filter(variantId => !allGiftVariantIds.includes(variantId));
    if(addedGiftVariantIdsNotInAllGifts.length) {
      for (let variantId of addedGiftVariantIdsNotInAllGifts) {
        updates[variantId] = 0;
      }
    }

    if (Object.keys(updates).length) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      }).then(res => res.json())
      .then(resJson => {
        if (resJson.item_count === 0) {
          document.querySelector('#main-cart-items-wrapper')?.classList.add('is-empty');
        }
      })

      await refreshCartDrawerContents();

      document.dispatchEvent(new CustomEvent('cart::updated'));
    }

    document.querySelector('#main-cart-items')?.classList.remove('loading');
  }

  // remove free gift if gwp condition isnt met
  function handleGWPOnceCartUpdated(isFirstLoad) {
    const domGwpArr = getGwpDataFromDom();
    if (isFirstLoad) {
      if (!domGwpArr) {
        return;
      }
      const gwpArr = domGwpArr;
      removeFreeGiftWithGWP(gwpArr);
      return;
    }

    if (domGwpArr) {
      removeFreeGiftWithGWP(domGwpArr);
      return;
    }

    fetch(`/cart`)
      .then((response) => response.text())
      .then(async (resp) => {
        const parser = new DOMParser();
        const cartDom = parser.parseFromString(resp, "text/html");
        const gwpArr = getGwpDataFromDom(cartDom);
        if (gwpArr) {
          removeFreeGiftWithGWP(gwpArr);
        }
      });
  }

  handleGWPOnceCartUpdated(true);
  document.addEventListener('cart::updated', handleGWPOnceCartUpdated);

  // listeners to variant options in GWP carousel
  document.querySelectorAll('.product-card-wrapper').forEach(wrapper => {
    const variantsData = wrapper.querySelector('#variants-data')?.textContent;
    if (!variantsData) {
      return;
    }
    const variants = JSON.parse(variantsData);
    const productForm = wrapper.querySelector('product-form form');

    wrapper.querySelectorAll('.product-form__input').forEach(formInput => {
      const radioOptions = formInput.querySelectorAll('[type="radio"]');

      radioOptions.forEach(ele => {
        ele.addEventListener('change', e => {
          const optionValues = [...wrapper.querySelectorAll('.product-form__input [type="radio"]:checked')].map(x => x.value);
          const existing = variants.find(x =>
            optionValues.every(val => x.options.includes(val))
          );
          // change variant id to add to cart
          if (productForm && existing) {
            productForm.querySelector('[name=id]').value = existing.id;
          }
        })
      });

      if (radioOptions.length) {
        // automatically choose the first option
        formInput.querySelector('[type="radio"] + label')?.click();
      } else {
        formInput.remove();
      }
    });

    wrapper.querySelectorAll('.pd-form-select').forEach(formInput => {
      const selectOption = formInput.querySelector('[name="selectVariant"]');
      if(!selectOption) return;
      selectOption.addEventListener('change', e => {
        const variantId = e?.target?.value;
        // change variant id to add to cart
        if (productForm && variantId) {
          productForm.querySelector('[name=id]').value = variantId;
        }
      });
    });
  })

  // set max-height for gwp card heading
  setTimeout(() => {
    const maxHeight = [...document.querySelectorAll('.pd-cart-gwp .card__heading a')].map(x => x.getBoundingClientRect()?.height).sort().at(-1);
    document.querySelectorAll('.pd-cart-gwp .card__information').forEach(x => x.style.setProperty(`--title-height`, `${maxHeight + 5}px`))
  }, 1000);

})();
